import { useContext, useEffect, useState } from "react";
import RefreshContext from "../RefreshContext";
import apiClient from "../lib/apiClient";
import { NavDropdown } from 'react-bootstrap';

export default function TimeRangePicker() {
  const [timeRanges, setTimeRanges] = useState(null);
  const [timeRange, setTimeRange] = useState(null);
  const { refresh } = useContext(RefreshContext);

  useEffect(() => {
    apiClient.get("/time_ranges")
      .then(({ data }) => {
        setTimeRanges(data.time_ranges);
        setTimeRange(data.current || data.time_ranges[0]);
      }).catch(console.error);
  }, []);

  function userSelectedTimeRange(time_range) {
    apiClient.get(time_range.path)
      .then(({ data }) => {
        setTimeRange(time_range);
        refresh();
      }).catch(console.error);
  }

  if (!timeRanges || !timeRange) {
    return "";
  }

  return (
    <NavDropdown title={timeRange.label || "Time Range"}
                 align="end"
                 className="ms-4 dropdown-menu-end"
                 id="timeRangeDropdownButton"
                 style={{ right: '2em', left: 'auto' }}>
      {timeRanges.map((timeRange, index) => {
        if (timeRange) {
          return (
            <NavDropdown.Item key={index}
                              style={{ marginRight: '2em' }}
                              onClick={() => userSelectedTimeRange(timeRange)}>
              {timeRange.label}
            </NavDropdown.Item>
          );
        } else {
          return <hr key={index} />;
        }
      })}
    </NavDropdown>
  )
}